import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import WhySection from "./components/WhySection";
import ComparisonSection from "./components/ComparisonSection";
import StepsSection from "./components/StepsSection";
import StatsSection from "./components/StatsSection";
import SecuritySection from "./components/SecuritySection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";
import ArticlePreview from "./components/ArticlePreview";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhySection />
        <ComparisonSection />
        <StepsSection />
        <StatsSection />
        <SecuritySection />
        <CTASection />
        <FAQSection />
        <ArticlePreview />
      </main>
      <Footer />
    </>
  );
}